
export const HasIconMixin = (target) => class extends target {
  static get fields() {
    return [
      { name: "hasContacts", persist: false },
      { name: "hasNotes", persist: false },
      // Server-provided flags for Media / Documents icon columns (Task, Resource, Client).
      // persist:false — omit from outgoing sync; do NOT use readOnly (Bryntum ignores set() on sync apply).
      {
        name: "hasMediaFiles",
        dataSource: "has_media_files",
        type: "boolean",
        persist: false,
        defaultValue: false,
      },
      {
        name: "hasDocumentFiles",
        dataSource: "has_document_files",
        type: "boolean",
        persist: false,
        defaultValue: false,
      },
      { name: "entityType", persist: false},
    ]
  }

  get hasContacts() {
    // For group headers this.contacts will be undefined
    return Boolean(this.contacts?.length)
  }

  get hasNotes() {
    return this.project?.boardNotesStore.some(note => note[this.entityType] === this.id);
  }
}
